// ErrorState — the shell's shared error surface. Composes Alert (danger) + a
// centered title + caller-supplied action buttons. Used by the two shell error
// tiers below the per-query 5-state contract (COMPONENTS §States, which pages
// own): the route-level errorElement (RouteError — uncaught crashes + lazy
// chunk-load failures) and the auth gate's server-error case (ProtectedRoute —
// a 5xx/network /me failure that must NOT be mistaken for a 401 logout).
//
// A layout composition (like ErrorBoundary), not a catalogued ui/ primitive —
// it only arranges existing primitives (Alert + the caller's Buttons/Links).

import type { ReactNode } from 'react';
import { Alert } from '../ui/Alert.js';

export interface ErrorStateProps {
  title: string;
  message: string;
  /** Recovery actions — Cancel/secondary left, primary right (COMPONENTS §Button). */
  actions: ReactNode;
}

export function ErrorState({ title, message, actions }: ErrorStateProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm space-y-4">
        <h1 className="text-xl font-bold text-center text-[var(--color-text-primary)]">{title}</h1>
        <Alert variant="danger">{message}</Alert>
        <div className="flex items-center justify-center gap-2">{actions}</div>
      </div>
    </div>
  );
}
